class TranslationService {
  constructor(translationProvider, language, targetLanguage, csrfToken) {
    this.translationProvider = translationProvider;
    this.language = language;
    this.targetLanguage = targetLanguage;
    this.csrfToken = csrfToken;
  }

  setTranslationProvider(translationProvider) {
    this.translationProvider = translationProvider;
  }

  // Fetches translation from the server
  fetchTranslation(wordText, sentenceText, language, translationProvider, callback) {
    // Remove punctuation at the start or end of the word
    wordText = wordText.replace(/^[.,\/#¿?¡!$%\^&\*;:{}=\-_"'`~()]+|[.,\/#¿?¡!$%\^&\*;:{}=\-_"'`~()]+$/g, '').trim();

    const translationPromise = fetch('https://translation-worker.lythamlabs.workers.dev', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        word: wordText,
        context_sentence: sentenceText,
        language: language,
        target_language: this.targetLanguage,
        translation_type: 'word'
      }),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    });

    const wordInfoPromise = fetch(`/langua/word_infos?word=${encodeURIComponent(wordText)}&language=${encodeURIComponent(language)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken
      }
    })
    .then(response => {
      if (!response.ok) {
        return null;
      }
      return response.json();
    });

    // Wait for both promises to resolve
    Promise.all([translationPromise, wordInfoPromise])
      .then(([translationData, wordInfoData]) => {
        if (translationData.translation) {
          translationData.context_sentence = sentenceText;
        }
        
        // Merge word info into translation data
        if (wordInfoData) {
          translationData.word_info = wordInfoData;
        }

        callback(translationData);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  // Translate a word and update UI
  translateWord(wordElement, currentSentence, callback) {
    const wordText = wordElement.innerText.trim();
    const sentenceText = currentSentence.trim(); // Assuming currentSentence is globally available

    if (wordElement.classList.contains('loading')) {
      return;
    }

    wordElement.classList.add('loading');
    // Fetch translation and update UI via callback
    this.fetchTranslation(wordText, sentenceText, this.language, this.translationProvider, callback);
  }

  // Translate a word and update UI
  translateSentence(currentSentence, callback) {
    const sentenceText = currentSentence.trim(); // Assuming currentSentence is globally available

    // Fetch translation and update UI via callback
    fetch('https://translation-worker.lythamlabs.workers.dev', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sentence: sentenceText,
        word: sentenceText,
        language: this.language,
        target_language: this.targetLanguage,
        translation_type: 'sentence'
      }),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      callback(data);
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

  // Translate a word and update UI
  translateMultiple(word, isInfinitive, callback) {

    // Fetch translation and update UI via callback
    fetch('https://translation-worker.lythamlabs.workers.dev', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        word: word,
        language: this.language,
        target_language: this.targetLanguage,
        translation_type: 'multiple',
        is_infinitive: isInfinitive
      }),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      callback(data);
    })
  }
}

export default TranslationService;
